// const source = 'podsDataTable'

function uploadRcuUnicoFile () {

  

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-rcu-unico',
      title: 'Rcu Unico Energia',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': uploadRcuUnicoFile,
}
